import { ApiResponse } from '@/api/api';

const MODE = import.meta.env.MODE; // 'development' or 'production'

interface FetchResponse<T> {
  success: boolean;
  code: number;
  message?: string;
  data: T;
}

export async function fetchAPI<T>({
  request
}: {
  request: () => Promise<ApiResponse<T>>;
}): Promise<FetchResponse<T>> {
  try {
    const res = await request();

    if (MODE === 'development') {
      console.debug('%c API response: ', 'color: #6ce9a6', res);
    }

    const isSuccess = res.code === 200 || res.code === 201;
    return {
      success: isSuccess,
      code: res.code,
      message: res.message,
      data: res.data as T
    };
  } catch (error) {
    console.error('Error during API request:', error);
    throw new Error('Failed to fetch API');
  }
}
